<template>
	<div class="m-address-list-page">
		<div v-for="section in sections" :key="section.type" class="m-address-section">
			<div class="m-address-section-header flex-between-center">
				<span class="m-address-section-title">{{section.title}}</span>
				<c-button color="main" prepend-icon="tf-add" @click="addAddress(section.type)">新增</c-button>
			</div>
			<div class="m-address-section-body">
				<div v-for="item in section.list" :key="item.id" class="m-address-item">
					<div class="m-address-item-main">
						<div class="m-address-item-contact">
							<span v-if="section.isWarehouse && item.description" class="m-address-item-name">{{item.description}}</span>
							<span class="m-address-item-name">{{item.name}}</span>
							<span class="m-address-item-phone">{{item.phone}}</span>
							<span v-if="!section.isWarehouse && item.is_default == 1" class="m-address-tag m-address-tag-default">默认</span>
							<span :class="['m-address-tag', item.is_enable == 1 ? 'm-address-tag-enable' : 'm-address-tag-disable']">{{item.is_enable == 1 ? '可用' : '禁用'}}</span>
						</div>
						<div class="m-address-item-body">
							<div class="m-address-item-text-row">
								<div class="m-address-item-text">{{item.full_address}}</div>
								<div class="m-address-item-controls">
									<div v-if="!section.isWarehouse" class="m-address-item-toggles">
										<span class="m-address-item-toggle-label">默认</span>
										<c-switch :value="item.is_default" :state-text="[' ', ' ']" :state-value="[1, 0]" @change="toggleField(item, 'is_default', section.type)"></c-switch>
									</div>
									<div v-if="!section.isWarehouse" class="m-address-item-toggles">
										<span class="m-address-item-toggle-label">可用</span>
										<c-switch :value="item.is_enable" :state-text="[' ', ' ']" :state-value="[1, 0]" @change="toggleField(item, 'is_enable', section.type)"></c-switch>
									</div>
									<div class="m-address-item-buttons">
										<c-button color="main" hollow @click="editAddress(item, section.type)">编辑</c-button>
										<c-button color="red" hollow @click="deleteAddress(item, section.type)">删除</c-button>
									</div>
								</div>
							</div>
							<div v-if="item.create_date" class="m-address-item-date">创建时间：{{item.create_date}}</div>
						</div>
					</div>
				</div>
				<c-empty v-if="!section.list.length" :message="`暂无${section.title}`"></c-empty>
			</div>
		</div>

		<address-edit-dialog ref="addressEdit" @success="loadData"></address-edit-dialog>
	</div>
</template>

<script>
	import addressEditDialog from './address_edit_dialog.vue'

	export default {
		name: 'addressList',
		props: {
			addressTypes: {type: [Array, String], default: () => [1, 2]},
			showTabs: {type: Boolean, default: true}
		},

		components: {
			addressEditDialog
		},

		data() {
			return {
				addressData: {
					1: [],
					2: [],
					3: []
				}
			}
		},

		computed: {
			availableTypes() {
				return (Array.isArray(this.addressTypes) ? this.addressTypes : this.addressTypes.toString().split(',')).map(Number);
			},

			sections() {
				var titles = {1: '发货地址', 2: '退货地址', 3: '回收质检仓'};
				return this.availableTypes.map(type => ({
					type: type,
					title: titles[type] || '地址管理',
					list: this.addressData[type] || [],
					isWarehouse: type === 3
				}));
			}
		},

		mounted() {
			this.loadData();
		},

		methods: {
			loadData() {
				this.availableTypes.forEach(type => this.loadAddressList(type));
			},

			loadAddressList(type) {
				this.request({
					url: '/sys_saas/address/list/noPage',
					data: {
						address_type: type
					},
					success: data => {
						this.$set(this.addressData, type, data || []);
					}
				});
			},

			addAddress(type) {
				this.$refs.addressEdit.open(null, type);
			},

			editAddress(data, type) {
				this.$refs.addressEdit.open(data, type);
			},

			deleteAddress(data, type) {
				this.$confirm({
					message: '确定删除该地址吗？',
					resolve: () => {
						this.request({
							url: '/sys_saas/address/delete',
							data: {id: data.id, address_type: type},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg || '删除成功', type: 'success'});
								this.loadData();
							}
						});
					}
				});
			},

			toggleField(data, field, type) {
				if (field == 'is_default') {
					this.request({
						url: '/sys_saas/address/setDefault',
						data: {
							id: data.id,
							is_default: data.is_default == 1 ? 0 : 1,
							address_type: type
						},
						loading: true,
						success: (res, msg) => {
							this.$message({message: msg || '设置成功', type: 'success'});
							this.loadData();
						}
					});
				} else if (field == 'is_enable') {
					this.request({
						url: '/sys_saas/address/setEnable',
						data: {
							id: data.id,
							address_type: type,
							is_enable: data.is_enable == 1 ? 0 : 1
						},
						loading: true,
						success: (res, msg) => {
							this.$message({message: msg || '设置成功', type: 'success'});
							this.loadData();
						}
					});
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-address-list-page {
		display: flex;
		flex-direction: column;
		gap: 12px;
		overflow: hidden;
		background: #fff;
	}

	.m-address-section {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-height: 0;
		border: 1px solid #eee;
		border-radius: 4px;
		overflow: hidden;
	}

	.m-address-section-header {
		padding: 10px 12px;
		border-bottom: 1px solid #eee;
		flex-shrink: 0;
		background: #fafafa;
	}

	.m-address-section-title-wrap {
		display: inline-flex;
		align-items: center;
		gap: 10px;
	}

	.m-address-section-title {
		font-size: 15px;
		font-weight: 600;
		color: #333;
	}

	.m-address-section-body {
		flex: 1;
		overflow-y: auto;
		padding: 4px 12px;
		min-height: 0;
	}

	.m-address-item {
		padding: 10px 0;
		border-bottom: 1px solid #f0f0f0;

		&:last-child {
			border-bottom: none;
		}
	}

	.m-address-item-main {
		min-width: 0;
	}

	.m-address-item-contact {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-bottom: 6px;
		flex-wrap: wrap;
	}

	.m-address-item-name {
		font-size: 14px;
		font-weight: 600;
		color: #333;
	}

	.m-address-item-phone {
		font-size: 13px;
		color: #666;
	}

	.m-address-item-body {
		padding-top: 2px;
	}

	.m-address-item-text-row {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 8px;
	}

	.m-address-item-text {
		flex: 1;
		min-width: 260px;
		font-size: 13px;
		color: #666;
		line-height: 1.5;
	}

	.m-address-item-controls {
		display: flex;
		align-items: center;
		gap: 16px;
		flex-shrink: 0;
		flex-wrap: wrap;
	}

	.m-address-item-date {
		font-size: 12px;
		color: #999;
		margin-top: 4px;
	}

	.m-address-tag {
		display: inline-block;
		padding: 1px 6px;
		font-size: 11px;
		border-radius: 2px;
		line-height: 16px;

		&.m-address-tag-default {
			background: #e8f4ff;
			color: #1890ff;
		}

		&.m-address-tag-enable {
			background: #e8f8e8;
			color: #52c41a;
		}

		&.m-address-tag-disable {
			background: #fff1f0;
			color: #ff4d4f;
		}
	}

	.m-address-item-toggles {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.m-address-item-toggle-label {
		font-size: 13px;
		color: #666;
	}

	.m-address-item-buttons {
		display: flex;
		gap: 8px;
	}

	.m-address-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 4px;
		height: 26px;
		padding: 0 10px;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		background: #fff;
		font-size: 12px;
		color: #333;
		cursor: pointer;
		transition: all 0.2s;

		&:hover {
			border-color: #1890ff;
			color: #1890ff;
		}

		&.m-address-btn-main {
			border-color: #1890ff;
			background: #1890ff;
			color: #fff;

			&:hover {
				background: #40a9ff;
				border-color: #40a9ff;
			}
		}

		&.m-address-btn-danger {
			border-color: #ff4d4f;
			color: #ff4d4f;
			background: #fff;

			&:hover {
				background: #ff4d4f;
				color: #fff;
			}
		}

		i {
			font-size: 12px;
		}
	}

	.m-address-empty {
		text-align: center;
		padding: 40px 0;
		color: #999;
		font-size: 14px;
	}

	.m-switch {
		display: inline-block;
		width: 36px;
		height: 20px;
		border-radius: 10px;
		background: #dcdcdc;
		position: relative;
		cursor: pointer;
		vertical-align: middle;
		transition: background 0.2s;

		&.z-open {
			background: #00b578;
		}

		.u-switch-dot {
			position: absolute;
			top: 2px;
			left: 2px;
			width: 16px;
			height: 16px;
			border-radius: 50%;
			background: #fff;
			transition: left 0.2s;
		}

		&.z-open .u-switch-dot {
			left: 18px;
		}
	}
</style>
